module.exports = __webpack_public_path__ + "static/images/half-star.4szp1n_.svg";